import React, { useState } from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'

import styles from './styles.module.scss'

export const OnDemandCard = React.forwardRef(
  (
    {
      img,
      title,
      link,
      length,
      style,
      className,
      index,
      categoryIndex,
      ...props
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false)

    return (
      <TransitionLink
        to={link}
        className={classNames(styles.card, className, {
          [styles.isSelected]: isSelected,
        })}
        activeClassName={styles.activeCard}
        entry={{ length: 1 }}
        exit={{
          length: 1,
          zIndex: 0,
        }}
        style={style}
        ref={ref}
        onClick={() => setIsSelected(true)}
        {...props}
        data-testid={`cardLink-${categoryIndex}-${index}`}
      >
        <div className={styles.cardImgWrapper}>
          <img className={styles.cardImg} src={img} alt="" />
        </div>
        <div className={styles.cardBody}>
          <div className={styles.cardHeader}>
            <h3
              className={styles.cardTitle}
              data-testid={`cardtitle-${categoryIndex}-${index}`}
            >
              {title}
            </h3>
            <div className={styles.cardData}>
              <span className={styles.data}>
                <FontAwesomeIcon icon="stopwatch" /> {length} min
              </span>
              {/* <span className={styles.data}>
            <FontAwesomeIcon icon="user-circle" /> {instructor}
          </span> */}
            </div>
          </div>
          <div className={styles.cardLink}>
            View Details{' '}
            <FontAwesomeIcon className={styles.chevron} icon="chevron-right" />
          </div>
        </div>
      </TransitionLink>
    )
  }
)

OnDemandCard.displayName = 'OnDemandCard'
